import React from 'react';
import EquationEditor from 'equation-editor-react';
import TextInput from '../../pages/NewExam/TextInput';
import './style.css'

var that = undefined;
export default class NuovoVF extends React.Component {
    constructor(props) {
        super(props);

        that = this;
        this.state = {
            domanda: '', 
            risposta_corretta: undefined, 
            trash: false, 
            deleted: false,
            error: false,
        };

    }

    getQuestion() {

        if (this.state.deleted) return { tipo: 'deleted' }

        if (this.state.domanda && this.state.risposta_corretta) {
            
            this.setState({ error: false });
            
            var res = {
                tipo: 0, 
                domanda: this.state.domanda,
                risposta: this.state.risposta_corretta, 
                allegato: this.state.attachment ? this.state.adding + ':///' + this.state.attachment : null,
            }
            return res;
        }

        this.setState({ error: true });
    }

    delete() {
        this.setState({ deleted: true });
    }

    handleFileSelected(e) {
        const files = Array.from(e.target.files)
        
        if (files[0].size <= 1048576) {
            let reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = function () {
                that.setState({ attachment: reader.result });
            };
        } else {
            alert("Scegliere un'immagine con una dimensione massima di 1MB");
        }
    }

    render() {

        if (this.state.deleted) return <div />;

        return(
            <section className='question-container'>
                { this.state.error && ( <p style={{ color: '#C13F3F', fontWeight: 'bold' }}>Verifica di aver inserito tutti i dati in questa domanda.</p> )}
                <TextInput placeholder={'Testo della domanda'} value={this.state.domanda} fontSize={20} onChange={(text) => this.setState({ domanda: text })} />
                <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                    { !this.state.adding && (
                        <>
                            <p style={{ color: 'blue', cursor: 'pointer', fontSize: 14, fontWeight: 'bold', marginRight: 20 }} onClick={() => this.setState({ adding: 'img', attachment: '' })}>Aggiungi immagine</p>
                            <p style={{ color: 'blue', cursor: 'pointer', fontSize: 14, fontWeight: 'bold' }} onClick={() => this.setState({ adding: 'math', attachment: 'y=x' })}>Aggiungi formula</p>
                        </>
                    )}

                    { this.state.adding === 'math' && (
                        <EquationEditor
                            value={this.state.attachment}
                            onChange={(equazione) => this.setState({ attachment: equazione })}
                            autoCommands="pi theta sqrt sum prod alpha beta gamma delta rho"
                            autoOperatorNames='sin cos tan arccos arcsen arctan'
                        />
                    )}
                    { this.state.adding === 'img' && (
                        <div style={{ flexDirection: 'column' }}>
                            <input type={'file'} onChange={this.handleFileSelected} />
                            { this.state.attachment && (
                                <img src={this.state.attachment} style={{ width: '50%', height: 'auto' }} />
                            )}
                        </div>
                    )}
                </section>
                <p style={{ color: '#818181', marginTop: 30, fontWeight: 'bold' }}>Risposta corretta:</p>
                <div className='answer-container'>
                    <section className='answer' style={{ backgroundColor: this.state.risposta_corretta === 1 ? '#C3F3B3' : 'white' }} onClick={() => this.setState({ risposta_corretta: 1 })}>Vero</section>
                    <section className='answer' style={{ backgroundColor: this.state.risposta_corretta === 2 ? '#C3F3B3' : 'white' }} onClick={() => this.setState({ risposta_corretta: 2 })}>Falso</section>
                </div>
                <img src={ require('../../images/trash.png') } style={{ position: 'absolute', right: 20, bottom: 20, width: 20, height: 20, cursor: 'pointer', opacity: this.state.trash ? 1 : 0.6 }} onMouseEnter={() => this.setState({ trash: true })} onMouseLeave={() => this.setState({ trash: false })} onClick={() => {
                    if (window.confirm('Vuoi davvero eliminare questa domanda?')) {
                        this.setState({ deleted: true });
                    }
                }} />
            </section>
        );
    }
}